export function getView(person) {
  if (person.is_patient) return 'Patient'
  if (person.is_employee) return 'Employee'
  if (person.is_external_professional) return 'ExternalProfessional'
  if (person.is_payer) return 'Payer'
  return 'No'
}
